import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ProjectInformation from "../../../components/ProjectInformation";
import { Col, Row } from "antd";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import DashboardPages from "../../../Dashboard/DashboardPages";
import Tables from "../../../components/Tables";
import {
  TYPE_CHECK_DASHBOARD,
  TYPE_GET_DATE,
  tableMytelDailyRevenue,
} from "../../../../helper/const";
import DailyRevenueChart from "../../../components/DailyRevenueChart";
import {
  formatDataDailyRevenueChart,
  formatDataNumberToen,
  formatDataQuantityMytelAuctionOverview,
  formatDataStatisticTableMytel,
  getDateChangeTime,
} from "../../../../helper/helper";
import { selectorDataMytel } from "../../../../redux/selector";
import { getDataRevenueMytel } from "../../../../redux/Future/Mytel/action";
import { apiRevenueMytel } from "../../../../api/ApiMytel";
import FilterTime from "../../../components/FilterTime";
import { idProject } from "../../../../helper/const";
import RevenueOfChannelChart from "../../../components/RevenueOfChannelChart";
import styled from "styled-components";

export default function Overview(tabActive) {
  const dispatch = useDispatch();
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  const { revenue = {} } = useSelector(selectorDataMytel);
  const { dataDetail = [], dataOverview = [] } = revenue.result || {};

  let dataDailyRevenueChart = [];

  useEffect(() => {
    dispatch(getDataRevenueMytel(apiRevenueMytel(startDate, endDate)));
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: [],
    xField: "time",
    yField: ["totalRevenue", "quantity"],

    annotations: {
      quantity: [],
    },
  };

  let columnsMytelRevenue = { dataKey: [], defineData: [] };
  let revenueOfChannel = {
    data: [],
    xField: "type",
    yField: ["revenue"],
  };

  useMemo(() => {
    quantityRevenue = formatDataQuantityMytelAuctionOverview(
      dataOverview,
      TYPE_CHECK_DASHBOARD.overview
    );

    revenueOfChannel = formatDataQuantityMytelAuctionOverview(
      dataOverview,
      TYPE_CHECK_DASHBOARD.revenue
    );

    const convertDataOverViews = dataOverview.map((item) => {
      return {
        ...item,
        titleConvert: item.title.replace("REVERSE_", "SUBASTA_"),
      };
    });
    columnsMytelRevenue = formatDataStatisticTableMytel(convertDataOverViews);
    // console.log(columnsMytelRevenue);
    dataDailyRevenueChart = formatDataDailyRevenueChart(dataDetail);

    //Daily Revenue Table
    const formatDataApi = dataDetail.map((item = {}) => {
      const { chargeTime = 0, packs, value = 0 } = item;
      const defineDataDailyRevenueTable = {
        REVERSE_DAILY: 0,
        REVERSE_WEEKLY: 0,
        REVERSE_MONTHLY: 0,
        REVERSE_BID_1: 0,
        REVERSE_BID_2: 0,
        REVERSE_BID_5: 0,
        REVERSE_BID_10: 0,
        REVERSE_BID_20: 0,
      };
      packs.forEach((packItem = {}) => {
        const idPack = packItem.id;
        defineDataDailyRevenueTable[idPack] = packItem.amount;
      });
      return {
        Chargetime: chargeTime,
        Day: defineDataDailyRevenueTable.REVERSE_DAILY,
        Week: defineDataDailyRevenueTable.REVERSE_WEEKLY,
        Month: defineDataDailyRevenueTable.REVERSE_MONTHLY,
        BID: defineDataDailyRevenueTable.REVERSE_BID_1,
        BID2: defineDataDailyRevenueTable.REVERSE_BID_2,
        BID5: defineDataDailyRevenueTable.REVERSE_BID_5,
        BID10: defineDataDailyRevenueTable.REVERSE_BID_10,
        BID20: defineDataDailyRevenueTable.REVERSE_BID_20,
        Dayrevenue: value,
      };
    });
    let total = {
      BID: 0,
      BID2: 0,
      BID5: 0,
      BID10: 0,
      BID20: 0,
      Chargetime: "Total",
      Day: 0,
      Dayrevenue: 0,
      Month: 0,
      Week: 0,
    };

    formatDataApi.forEach((item) => {
      total.Day += item.Day || 0;
      total.Week += item.Week || 0;
      total.Month += item.Month || 0;
      total.BID += item.BID || 0;
      total.BID2 += item.BID2 || 0;
      total.BID5 += item.BID5 || 0;
      total.BID10 += item.BID10 || 0;
      total.BID20 += item.BID20 || 0;
      total.Dayrevenue += item.Dayrevenue || 0;
    });

    for (const key in total) {
      if (typeof total[key] === "number") {
        total[key] = parseFloat(total[key].toFixed(3));
      }
    }
    let data = [total, ...formatDataApi].reverse();
    tableMytelDailyRevenue.defineData = data.map((item) => {
      for (let x in item) {
        if (typeof item[x] === "number") {
          item[x] = formatDataNumberToen(item[x]);
        }
      }
      return item;
    });
  }, [revenue.result]);
  return (
    <Container className="reponsitite-container">
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <Row className="panel panel-sortable">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24}>
            <Row>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">
                  Overview Quantity - Revenue chart:
                </h4>
                <div className="item-chart">
                  <DashboardPages dataDashboard={quantityRevenue} />
                </div>
              </Col>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">Revenue of channel chart:</h4>

                <div className="item-chart">
                  <RevenueOfChannelChart dataChart={revenueOfChannel} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div id="table-bitel">
        <Tables
          columns={columnsMytelRevenue}
          title="Overview statistic table"
          isHiddenPagination={false}
        />
      </div>
      <div className="container-dashboard pt-0">
        <Row className="panel panel-sortable">
          <Title titleName="Daily Revenue Chart">
            <BranchesOutlined />
          </Title>
          <div className="container-revenueOfChannelChart">
            <div className="revenueOfChannelChart">
              <DailyRevenueChart dataRevenueChart={dataDailyRevenueChart} />
            </div>
          </div>
        </Row>
      </div>
      <Tables columns={tableMytelDailyRevenue} title="Daily Revenue Table" />
      <ProjectInformation id={idProject.mytel} />
    </Container>
  );
}

const Container = styled.div`
  .container-revenueOfChannelChart {
    width: 100%;
    overflow-x: auto;
  }

  .revenueOfChannelChart {
    min-width: 800px;
    overflow-x: scroll;
  }
`;
